import ToolShell, { OutputBlock } from "@/pages/tools/ToolShell";

export default function GoogleAds() {
  return (
    <ToolShell
      testid="tool-google-ads-page"
      eyebrow="Pro Tool" toolKey="google_ads"
      title="Google Ads Generator"
      subtitle="Search + Performance Max copy, keywords and assets - ready to paste into Google Ads Editor."
      endpoint="/tools/google-ads"
      tier="pro"
      transformPayload={(s) => ({ brief: s })}
      fields={[
        { key: "offer", label: "What are you advertising?", type: "textarea", rows: 3, required: true, placeholder: "e.g. Liveaboard booking in Komodo, 7 nights, October" },
        { key: "landing_page", label: "Landing page URL (optional)", type: "text", placeholder: "https://…" },
        { key: "region", label: "Region / language (optional)", type: "text", placeholder: "e.g. UK, English" },
      ]}
      renderOutput={(o) => (
        <>
          <OutputBlock testid="output-keywords" label="Keywords" copyValue={(o.keywords || []).join("\n")}>
            <div className="flex flex-wrap gap-2">{(o.keywords || []).map((k, i) => <span key={i} className="dms-badge">{k}</span>)}</div>
          </OutputBlock>
          <OutputBlock testid="output-negatives" label="Negative Keywords">
            <div className="flex flex-wrap gap-2">{(o.negative_keywords || []).map((k, i) => <span key={i} className="dms-badge bg-[#FEE2E2] text-[#991B1B]">{k}</span>)}</div>
          </OutputBlock>
          {o.search_ad && (
            <OutputBlock testid="output-search-ad" label="Search Ad">
              <div className="space-y-3 text-[14.5px]">
                <div><span className="dms-label">Headlines</span>
                  <ul className="mt-1 list-disc pl-5 space-y-0.5">
                    {(o.search_ad.headlines || []).map((h, i) => <li key={i}>{h} <span className="text-xs text-[#94A3B8]">({(h || "").length})</span></li>)}
                  </ul>
                </div>
                <div><span className="dms-label">Descriptions</span>
                  <ul className="mt-1 list-disc pl-5 space-y-0.5">
                    {(o.search_ad.descriptions || []).map((h, i) => <li key={i}>{h} <span className="text-xs text-[#94A3B8]">({(h || "").length})</span></li>)}
                  </ul>
                </div>
                <div><span className="dms-label">Final URL Path</span><div className="mt-1">/{o.search_ad.final_url_path}</div></div>
              </div>
            </OutputBlock>
          )}
          {o.pmax_assets && (
            <OutputBlock testid="output-pmax" label="Performance Max Assets">
              <div className="space-y-3 text-[14.5px]">
                <div><span className="dms-label">Headlines</span><div className="mt-1">{(o.pmax_assets.headlines || []).join(" · ")}</div></div>
                <div><span className="dms-label">Long Headlines</span><div className="mt-1">{(o.pmax_assets.long_headlines || []).join(" · ")}</div></div>
                <div><span className="dms-label">Descriptions</span><div className="mt-1">{(o.pmax_assets.descriptions || []).join(" · ")}</div></div>
                <div><span className="dms-label">Image Briefs</span><ul className="mt-1 list-disc pl-5">{(o.pmax_assets.image_briefs || []).map((b, i) => <li key={i}>{b}</li>)}</ul></div>
                <div><span className="dms-label">Video Briefs</span><ul className="mt-1 list-disc pl-5">{(o.pmax_assets.video_briefs || []).map((b, i) => <li key={i}>{b}</li>)}</ul></div>
              </div>
            </OutputBlock>
          )}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <OutputBlock testid="output-callouts" label="Callouts">
              <div className="flex flex-wrap gap-2">{(o.callout_extensions || []).map((k, i) => <span key={i} className="dms-badge">{k}</span>)}</div>
            </OutputBlock>
            <OutputBlock testid="output-sitelinks" label="Sitelink Titles">
              <div className="flex flex-wrap gap-2">{(o.sitelink_titles || []).map((k, i) => <span key={i} className="dms-badge">{k}</span>)}</div>
            </OutputBlock>
          </div>
        </>
      )}
    />
  );
}
